import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type StockStatus = 'in_stock' | 'out_of_stock' | 'limited' | 'unknown' | string;

const LABELS: Record<string, string> = {
  in_stock: 'IN STOCK',
  out_of_stock: 'OUT',
  limited: 'LOW STOCK',
  unknown: 'UNKNOWN',
};

/** Colored availability pill. Color encodes the same info as the label so it
 * does not rely on color alone (WCAG 1.4.1). */
export function StockPill({
  status,
  size = 'md',
  sx,
}: {
  status: StockStatus;
  size?: 'sm' | 'md';
  sx?: React.ComponentProps<typeof Box>['sx'];
}) {
  const theme = useTheme();
  const t = theme.palette.tactical;
  const label = LABELS[status] ?? String(status).toUpperCase();
  const c =
    status === 'out_of_stock'
      ? t.red
      : status === 'limited'
        ? theme.palette.warning.main
        : status === 'unknown'
          ? t.dim
          : t.green;
  const compact = size === 'sm';
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: compact ? 0.75 : 1,
        py: compact ? 0.25 : 0.5,
        borderRadius: 1.5,
        bgcolor: t.bg,
        border: `1px solid ${c}`,
        fontFamily: t.monoFont,
        fontSize: compact ? 9 : 10,
        lineHeight: 1.4,
        color: c,
        letterSpacing: '0.08em',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      <Box component="span" sx={{ width: 5, height: 5, bgcolor: c, borderRadius: '50%' }} />
      {label}
    </Box>
  );
}

export default StockPill;
